module.exports = require('./helpers/bundle-url').getBundleURL('3Ntop') + "logo-dark.eefe0b7f.svg";